import React, { useState, useEffect } from 'react';
import '../css/HeroSlider.css';

const HeroSlider = () => {
  // Slider Banners List (Aap yahan apni custom banner image ka path update kar sakte hain)
  const slides = [
    {
      id: 1,
      image: "https://images.unsplash.com/photo-1541829019-2592e6274bc6?q=80&w=1600&auto=format&fit=crop", 
      title: "BEST SAFETY TRAINING INSTITUTE AWARD",
      subtitle: "Honored for Excellence in Safety Training and Building a Safer Tomorrow"
    },
    {
      id: 2,
      image: "https://images.unsplash.com/photo-1504384308090-c894fdcc538d?q=80&w=1600&auto=format&fit=crop",
      title: "NEBOSH GOLD LEARNING PARTNER",
      subtitle: "International Standard Safety Education With 100% Practical Exposure"
    },
    {
      id: 3,
      image: "https://images.unsplash.com/photo-1581092921461-eab62e97a780?q=80&w=1600&auto=format&fit=crop",
      title: "INDUSTRIAL FIRE & SAFETY ADMISSIONS OPEN",
      subtitle: "Join Now for Premium Diploma & HSE Certification Courses"
    }
  ];

  const [currentSlide, setCurrentSlide] = useState(0);

  // Auto-slide transition timing (4 seconds)
  useEffect(() => {
    const slideInterval = setInterval(() => {
      setCurrentSlide((prev) => (prev === slides.length - 1 ? 0 : prev + 1));
    }, 4000);
    return () => clearInterval(slideInterval);
  }, [slides.length]);

  return (
    <div className="gfi-hero-section-wrapper">
      
      {/* 1. INTERACTIVE IMAGE SLIDER BOX */}
      <div className="gfi-slider-viewport">
        {slides.map((slide, index) => (
          <div 
            key={slide.id} 
            className={`gfi-slide-frame ${index === currentSlide ? 'active' : ''}`}
            style={{ backgroundImage: `linear-gradient(rgba(0, 45, 98, 0.45), rgba(0, 0, 0, 0.65)), url(${slide.image})` }}
          >
            <div className="gfi-slide-caption-box">
              <span className="gfi-slide-tagline">🔥 GREENFIELD ACADEMY CAMPUS DIRECT</span>
              <h1 className="gfi-slide-heading">{slide.title}</h1>
              <p className="gfi-slide-subtext">{slide.subtitle}</p>
              <div className="gfi-slide-action-row">
                <a href="#explore" className="gfi-slide-btn primary">Our Courses 🎓</a>
                <a href="#contact" className="gfi-slide-btn secondary">Apply Online 📝</a>
              </div>
            </div>
          </div>
        ))}

        {/* Dynamic Dots Indicator */}
        <div className="gfi-slider-indicators">
          {slides.map((_, index) => (
            <span 
              key={index} 
              className={`gfi-dot ${index === currentSlide ? 'active' : ''}`}
              onClick={() => setCurrentSlide(index)}
            ></span>
          ))}
        </div>
      </div>

      {/* 2. STATS INFO GRID MESH (Screenshot 7 Exact Replica) */}
      <div className="gfi-stats-floating-grid">
        <div className="gfi-container-row">
          
          {/* Card 1 */}
          <div className="gfi-stat-card standard-white-card">
            <div className="gfi-s-card-icon blue-tint">📅</div>
            <h3 className="gfi-s-card-num">16<sup>+</sup></h3>
            <p className="gfi-s-card-label">YEARS OF EXCELLENCE</p>
          </div>

          {/* Card 2 */}
          <div className="gfi-stat-card standard-white-card">
            <div className="gfi-s-card-icon blue-tint">🎓</div>
            <h3 className="gfi-s-card-num">10,000<sup>+</sup></h3>
            <p className="gfi-s-card-label">STUDENTS TRAINED</p>
          </div>

          {/* Card 3: Standout Deep Blue Custom Card */}
          <div className="gfi-stat-card standout-blue-card">
            <div className="gfi-s-card-icon white-tint">🌐</div>
            <h3 className="gfi-s-card-num">GOLD</h3>
            <p className="gfi-s-card-label">NEBOSH LEARNING PARTNER</p>
          </div>

          {/* Card 4 */}
          <div className="gfi-stat-card standard-white-card">
            <div className="gfi-s-card-icon blue-tint">📍</div>
            <h3 className="gfi-s-card-num">10<sup>+</sup></h3>
            <p className="gfi-s-card-label">TRAINING CENTERS</p>
          </div>

          {/* Card 5 */}
          <div className="gfi-stat-card standard-white-card">
            <div className="gfi-s-card-icon blue-tint">💼</div>
            <h3 className="gfi-s-card-num">80<sup>%</sup></h3>
            <p className="gfi-s-card-label">PLACEMENT RATE</p>
          </div>

        </div>
      </div>

    </div>
  );
};

export default HeroSlider;